export default class ContactForm {
  fileInputs: NodeListOf<HTMLInputElement>
  clearForms: NodeListOf<HTMLElement>

  constructor() {
    this.fileInputs = document.querySelectorAll('.wpcf7-file') as NodeListOf<HTMLInputElement>
    this.clearForms = document.querySelectorAll('.clear-form') as NodeListOf<HTMLElement>
    this.init()
  }

  init() {
    this.showName()
    this.clearInput()
  }

  clearInput() {
    this.clearForms &&
      this.clearForms.forEach(clearForm => {
        clearForm.addEventListener('click', () => {
          const parent = clearForm.parentNode as HTMLElement
          const file = parent?.querySelector('.wpcf7-file') as HTMLInputElement
          const fileName = parent?.querySelector('.file-name') as HTMLSpanElement

          file.files = null
          fileName.innerHTML = ''
          parent.classList.remove('is-active')
        })
      })
  }
  showName() {
    if (this.fileInputs) {
      this.fileInputs.forEach(fileInput => {
        fileInput.addEventListener('change', () => {
          const parent = fileInput.parentNode as HTMLElement
          const fileNameContent = fileInput.value.split('\\').pop()
          const fileName = parent?.parentNode.querySelector('.file-name') as HTMLSpanElement

          fileName.innerHTML = fileNameContent

          parent.parentNode.classList.add('is-active')
        })
      })
    }
  }
}
